/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface WebTraderConfig
 */
export class WebTraderConfig {
    /**
     *
     * @type {string}
     * @memberof WebTraderConfig
     */
    type: WebTraderConfigTypeEnum;
    /**
     *
     * @type {string}
     * @memberof WebTraderConfig
     */
    id: string;
    /**
     *
     * @type {string}
     * @memberof WebTraderConfig
     */
    generateTokenUrl: string;
    /**
     *
     * @type {string}
     * @memberof WebTraderConfig
     */
    generateTokenFallback: string;
    /**
     *
     * @type {string}
     * @memberof WebTraderConfig
     */
    secret: string;
    /**
     *
     * @type {string}
     * @memberof WebTraderConfig
     */
    tradingUrl: string;
}

/**
 * @export
 * @enum {string}
 */
export enum WebTraderConfigTypeEnum {
    Sirix = 'sirix',
    Mt4 = 'mt4',
}
